import { useQuery } from "@tanstack/react-query";
import { getUserGroupSub } from "../api/admin";

const useGetUserGroupSub = () => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [`UserGroupSub`],
    queryFn: () => getUserGroupSub(),

    enabled: true,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 0,
  });
  return { data, isLoading, isSuccess };
};

export default useGetUserGroupSub;
